import { AsyncStatus } from '../../../common/enums';
import * as dv from '../../../common/interfaces';
import { AxiosError } from 'axios';
import { Pagination } from '../../../common/interfaces/report';
import { GridRow } from '../../../components/Grid/Grid.interface';
import { AsyncResult } from '../../../store';
import { RowUpsert } from '../Details/RowUpsert';

export const getRowSheetIdFromViewData = (viewData: AsyncResult<dv.ViewData, AxiosError>, selectedRowId: string, intakeSheetId?: number | null) => {
    if (viewData.status !== AsyncStatus.DONE && viewData.status !== AsyncStatus.PARTIAL) {
        return;
    }
    const rowIdAsNumber = parseInt(selectedRowId, 10);
    const foundRow = viewData.data.rows.find((row) => row.id === rowIdAsNumber);
    if (!foundRow) {
        return intakeSheetId;
    }
    return foundRow.sheetId;
};

export const getRowSheetId = ({
    selectedRowId,
    configData,
    viewData,
    reportData,
    reportsDecoupleEnabledForReports,
    currentRowUpserts,
}: {
    selectedRowId?: string;
    configData: AsyncResult<dv.ViewWithOwnerAndUserDetails, AxiosError>;
    viewData: AsyncResult<dv.ViewData, AxiosError>;
    reportData: AsyncResult<{ rows: GridRow[]; pagination: Pagination }, AxiosError | Error>;
    reportsDecoupleEnabledForReports: boolean;
    currentRowUpserts?: RowUpsert[];
}) => {
    if (configData.status !== AsyncStatus.DONE) {
        return;
    }

    const { config } = configData.data;

    if (!selectedRowId) {
        // when this is null, submit to intake sheet (new row insert)
        return config?.intakeSheetId ?? undefined;
    }

    if (reportsDecoupleEnabledForReports && (reportData.status === AsyncStatus.DONE || reportData.status === AsyncStatus.PARTIAL)) {
        const selectedRow = reportData.data.rows.find((row) => row.id === selectedRowId);
        if (selectedRow) {
            return selectedRow.gridId;
        }

        // If the row is not found in the report data, it could mean that a new row has just been added. If that is the case we can try to get the
        // sheetId from the first row upsert object within the currentRowUpserts.
        if (Array.isArray(currentRowUpserts) && currentRowUpserts.length >= 1) {
            return currentRowUpserts[0].sheetId;
        }

        return;
    }
    return getRowSheetIdFromViewData(viewData, selectedRowId, config?.intakeSheetId) ?? undefined;
};
